import { connectToParent } from "penpal";
import type { OpenOSContext } from "ic-analytics";

interface OSApi {
    getAccessToken: () => Promise<string>;
}

export async function getWppToken() {
    const connection = connectToParent<{ osApi: OSApi }>({
        timeout: 1500
    });

    const { osApi } = await connection.promise;

    return osApi.getAccessToken();
}

export async function getWppContext(handleWppContext: (osContext: OpenOSContext) => void) {
    const connection = connectToParent<{ osApi: OSApi }>({
        timeout: 1500,
        methods: {
            receiveOsContext: (osContext: OpenOSContext) => {
                if (handleWppContext && osContext) {
                    handleWppContext(osContext);
                }
            }
        }
    });

    try {
        await connection.promise;
    } catch (error) {
        console.error("Failed to get WPP context:", error);
        throw error;
    }
}
